function fixedMenu() {
    const header = document.querySelector('header.set_menu_devices');
    window.addEventListener('scroll', () => {
        const scroll = window.scrollY;
        if( scroll > 100 ) {
            header.classList.add('bg-tap-header');
        } else {
            header.classList.remove('bg-tap-header');
        }
    });
}
export { fixedMenu }
